import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Field, reduxForm } from 'redux-form'

import { ReduxTextField } from '../../../components/reduxFormFields'

class AuthenticatorForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  }

  componentDidMount() {}

  render() {
    const { handleSubmit, loading } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name="googleAuthenticatorCode"
          component={ReduxTextField}
          placeholder="Google Authenticator Code"
          helperText="Enter the code from Google Authenticator"
          fullWidth
        />

        <div className="card-actions">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            className="btn-submit"
          >
            {loading ? (
              <CircularProgress size={20} thickness={5} />
            ) : (
              <span>Submit</span>
            )}
          </Button>
        </div>
      </form>
    )
  }
}

const validate = (values) => {
  const errors = {}

  if (!values.googleAuthenticatorCode) {
    errors.googleAuthenticatorCode = 'Required'
  }

  return errors
}

const AuthenticatorReduxForm = reduxForm({
  form: 'googleAuthenticator',
  validate,
})(AuthenticatorForm)

export default AuthenticatorReduxForm
